var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],attrs:{"icon":"arrow_upward","type":"flat","color":"primary","title":"Move to top"},on:{"click":_vm.scrollTop}})}
var staticRenderFns = []

export { render, staticRenderFns }